/* Display name for an office.
 *
 * Angular Module: "trackerbase-app.filters.office-display-name-filter"
 * Filter exposed as: tbOfficeDisplayName
 */

import angular from "angular";
import Office from "../models/Office";

function OfficeDisplayNameFilterFactory() {
    return Office.formatDisplayName;
}

OfficeDisplayNameFilterFactory.$inject = [];

export default angular
    .module("trackerbase-app.filters.office-display-name-filter", [])
    .filter("tbOfficeDisplayName", OfficeDisplayNameFilterFactory)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/filters/OfficeDisplayNameFilter.js
// module id = ENvx
// module chunks = 1